import type { DotnetExports } from "./dotnetExports";
import { getObjectValueByPath } from "@/common/lib";
import { useBusEmitterListener } from "../bridge";
import { setupExports } from "./dotnetExports";

type RuntimeAPI = ReturnType<typeof getDotnetRuntime> & object;
async function getExports(runtime: RuntimeAPI, assemblyName: string, namespace: string) {
  const exports: unknown = await runtime.getAssemblyExports(assemblyName);
  const dotnetExports = getObjectValueByPath<Partial<DotnetExports>>(exports, namespace);
  if (!dotnetExports) {
    console.warn(`No dotnet exports found for namespace '${namespace}'`);
    if (exports) {
      console.warn("Current dotnet exports", exports);
    }
  }
  return dotnetExports;
}

const dotnetReadyEvent = Symbol("bridge:dotnetReady");

const {
  emitter: dotnetReady,
  listener: onDotnetReady,
} = useBusEmitterListener(dotnetReadyEvent);

async function setupDotnetExports() {
  const runtime = globalThis.getDotnetRuntime(0);
  if (!runtime) {
    throw new Error("Couldn't locate dotnet runtime. Make sure that it is imported.");
  }
  const dotnetExports = [
    await getExports(runtime, "Platform.Web", "Axure.Platform.Web.Interop.JSExports"),
    await getExports(runtime, "Client.Web", "Axure.Client.Web.Interop.JSExports"),
    await getExports(runtime, "WebRP.Client", "WebRP.Client.JSExports"),
  ];

  for (const exports of dotnetExports) {
    if (exports) {
      setupExports(exports);
    }
  }

  dotnetReady();
}

export {
  onDotnetReady,
  setupDotnetExports,
};
